import Services from "./Services";
import Portfolio from "./Portfolio";
import Pricing from "./Pricing";
import Contact from "./Contact";
import Footer from "./Footer";
import Location from "./Location";

export default function Main () {
    return (
        <main id="main">
            <Services></Services>
            <Contact></Contact>
            <Portfolio></Portfolio>
            <Pricing></Pricing>
            <Location></Location>
            <Footer></Footer>
        </main>
    )
};